import { S_MainButton } from "component_old/micro/action/MainButton"
import { S_MobileOnly } from "component_old/micro/responsive/responsive"
import { S_AwesomeIcon } from "component_old/micro/view/AwesomeIcon"
import { CtxModal } from "component_old/modal/ctxModal"
import { SVG_Logo, S_SVG_Logo } from "libs/images/SVG_Logo"
import { EColors, EFonts } from "libs/style/styling"
import React, { useContext } from "react"
import styled from "styled-components/macro"

export const TopBar = (): JSX.Element => {
  const ctxModal = useContext(CtxModal)

  const Beta = <S_Beta>BETA</S_Beta>

  return (
    <S_TopBar>
      <S_Bar>
        <S_LeftTopBar>
          <SVG_Logo />
          {/* <S_DesktopOnly>{Beta}</S_DesktopOnly> */}
        </S_LeftTopBar>
        {/* <S_RightTopBar>
          <S_MobileOnly>
            <AwesomeIcon
              icon={faBars}
              iconSize="20px"
              color={EColors.WHITE}
              onClick={() => {
                ctxModal.changeModal("mobileMenu")
              }}
            />
          </S_MobileOnly>
          <S_DesktopOnly>
            <TopMenu />
          </S_DesktopOnly>
          <MainButton
            text={Localization.LOGIN}
            type="primary"
            shadow={EShadows.STRONG}
            onClick={() => {
              window.location.href = "https://app.mapheim.com/login"
            }}
          />
        </S_RightTopBar> */}
      </S_Bar>
      <S_MobileOnly>
        {/* <S_BetaLanguage>{Beta}</S_BetaLanguage> */}
      </S_MobileOnly>
    </S_TopBar>
  )
}

export const S_TopBar = styled.div`
  display: flex;
  flex-direction: column;
`

const S_Bar = styled.div`
  display: flex;
  justify-content: space-between;
  ${S_SVG_Logo} {
    svg {
      width: 135px;
      height: auto;
    }
  }
  @media only screen and (min-width: 1260px) {
    margin: 20px 0 0 0;
    ${S_SVG_Logo} {
      svg {
        width: 170px;
        height: auto;
      }
    }
  }
`

const S_Beta = styled.span`
  color: ${EColors.ACC2_A};
  font-size: 14px;
  font-family: ${EFonts.Bold};
  margin: 0 15px 0 0;
  @media only screen and (min-width: 1260px) {
    font-size: 16px;
  }
`

const S_LeftTopBar = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (min-width: 1260px) {
    ${S_Beta} {
      margin: 0 0 0 25px;
    }
  }
`

const S_RightTopBar = styled.div`
  display: flex;
  align-items: center;
  > ${S_MobileOnly} > ${S_AwesomeIcon} {
    margin: 0 20px 0 0;
  }
  @media only screen and (min-width: 1260px) {
    ${S_MainButton} {
      margin: 0 0 0 25px;
    }
  }
`

const S_BetaLanguage = styled.div`
  display: flex;
  margin: 5px 0 0 0;
`
